var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart"},[_c('Chart',{attrs:{"height":_vm.height,"id":_vm.id,"option":_vm.option,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }